<template>
  <div class="com-fm">
    <div class="img-box" v-for="i in fmInfoList" :key="i.id">
      <el-image
        @click="selectChange(i.id)"
        :class="fmId == i.id ? 'fm-img active' : 'fm-img'"
        fit="cover"
        :src="i.attachUrl"
        alt
      ></el-image>
      <el-button
        v-if="i.sourceType != 'local'"
        class="del-up"
        @click="delUpFm(i.id)"
        icon="el-icon-delete"
      ></el-button>
    </div>
    <upload-link
      v-if="fmInfoList.every(i => i.sourceType == 'local')"
      class="up-box"
      ref="upFm"
      :showFileList="false"
      :limit="1"
      :multiple="false"
      accept=".png, .jpg, .jpeg"
      @changeUpload="uploadFile"
    >
      <template slot="body">
        <el-button class="fm-body-btn" icon="el-icon-plus"></el-button>
      </template>
    </upload-link>
  </div>
</template>

<script>
import UploadLink from "@/components/upload/UploadLink.vue";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    UploadLink
  },
  model: {
    prop: "faceAttaches",
    event: "change"
  },
  props: {
    faceAttaches: {
      type: Array
    }
  },
  computed: {
    ...mapState(["userInfo", "schoolList", "resOptions"])
  },
  data() {
    return {
      //封面
      fmId: "",
      fmInfoList: [
        {
          id: 1631007742434,
          attachName: "1.jpg",
          attachSize: 53,
          attachType: "jpg",
          attachUrl: "./cover/1.jpg",
          sourceType: "local",
        },
        {
          id: 1631007742435,
          attachName: "3.jpg",
          attachSize: 37,
          attachType: "jpg",
          attachUrl: "./cover/3.jpg",
          sourceType: "local",
        },
        {
          id: 1631007742436,
          attachName: "4.jpg",
          attachSize: 38,
          attachType: "jpg",
          attachUrl: "./cover/4.jpg",
          sourceType: "local",
        },
        {
          id: 1631007742437,
          attachName: "2.jpg",
          attachSize: 37,
          attachType: "jpg",
          attachUrl: "./cover/2.jpg",
          sourceType: "local",
        },
        {
          id: 1631007742438,
          attachName: "5.jpg",
          attachSize: 33,
          attachType: "jpg",
          attachUrl: "./cover/5.jpg",
          sourceType: "local",
        },
        {
          id: 1631007742439,
          attachName: "6.jpg",
          attachSize: 37,
          attachType: "jpg",
          attachUrl: "./cover/6.jpg",
          sourceType: "local",
        },
        {
          id: 1631007742440,
          attachName: "7.jpg",
          attachSize: 38,
          attachType: "jpg",
          attachUrl: "./cover/7.jpg",
          sourceType: "local",
        },
        {
          id: 1631007742441,
          attachName: "8.jpg",
          attachSize: 37,
          attachType: "jpg",
          attachUrl: "./cover/8.jpg",
          sourceType: "local",
        },
        {
          id: 1631007742442,
          attachName: "9.jpg",
          attachSize: 33,
          attachType: "jpg",
          attachUrl: "./cover/9.jpg",
          sourceType: "local",
        },
        {
          id: 1631007742443,
          attachName: "10.jpg",
          attachSize: 33,
          attachType: "jpg",
          attachUrl: "./cover/10.jpg",
          sourceType: "local",
        },
        {
          id: 1631007742429,
          attachName: "1.png",
          attachSize: 53,
          attachType: "png",
          attachUrl: "./cover/1.png",
          sourceType: "local"
        },
        {
          id: 1631007742430,
          attachName: "2.png",
          attachSize: 37,
          attachType: "png",
          attachUrl: "./cover/2.png",
          sourceType: "local"
        },
        {
          id: 1631007742431,
          attachName: "3.png",
          attachSize: 38,
          attachType: "png",
          attachUrl: "./cover/3.png",
          sourceType: "local"
        },
        {
          id: 1631007742432,
          attachName: "4.png",
          attachSize: 37,
          attachType: "png",
          attachUrl: "./cover/4.png",
          sourceType: "local"
        },
        {
          id: 1631007742433,
          attachName: "5.png",
          attachSize: 33,
          attachType: "png",
          attachUrl: "./cover/5.png",
          sourceType: "local"
        }
      ]
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.faceAttaches.length > 0) {
        this.fmInfoList.push(this.faceAttaches[0]);
        this.fmId = this.faceAttaches[0].id;
      }
    },
    //封面
    uploadFile(fileList) {
      let temId = new Date().getTime();
      fileList.forEach(item => (item.id = temId));
      this.fmInfoList.push(fileList[0]);
    },
    selectChange(id) {
      this.fmId = id;
    },
    delUpFm(id) {
      this.fmInfoList = this.fmInfoList.filter(i => i.id != id);
      if (this.fmId == id) {
        this.fmId = "";
      }
    }
  },
  watch: {
    fmId: {
      handler(val, oldVal) {
        this.$emit(
          "change",
          this.fmInfoList.filter(i => i.id == val)
        );
      }
    }
  }
};
</script>
<style lang="less" scoped>
.com-fm {
  .img-box {
    display: inline-block;
    position: relative;
    width: 33%;
    .fm-img {
      height: 120px;
      cursor: pointer;
      // width: 316px;
      border-radius: 10px;
      margin-right: 12px;
      margin-bottom: 12px;
      vertical-align: middle;
      border: 3px solid #fff;
    }
    .fm-img:hover {
      border: 3px solid @color;
    }
    .active {
      border: 3px solid @color;
    }
    .del-up {
      position: absolute;
      right: 28px;
      top: 10px;
      border: 1px solid rgba(146, 145, 145, 0);
      z-index: 20;
      color: rgb(247, 118, 118);
      font-size: 20px;
      background: none;
      padding: 5px;
    }
  }
  .up-box {
    height: 120px;
    cursor: pointer;
    width: 210px;
    border-radius: 10px;
    margin-right: 12px;
    margin-bottom: 12px;
    vertical-align: middle;
    border: 3px solid #fff;
    display: inline-block;
    .fm-body-btn {
      height: 120px;
      width: 205px;
      border-radius: 10px;
      margin-right: 12px;
      margin-bottom: 12px;
      vertical-align: middle;
      /deep/.el-icon-plus {
        font-size: 30px;
        color: #8c939d;
      }
    }
  }
}
</style>
